
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M15.592 11.033h-2.18V7.447a.234.234 0 10-.469 0v3.586H8.871v-1.015a.234.234 0 00-.235-.235H6.283V4.196h2.662v.964c0 .207.168.374.374.374h.588a.375.375 0 00.375-.374v-.964h2.662V6.51a.234.234 0 10.468 0V4.135a.409.409 0 00-.408-.408H8.071V.415a.409.409 0 00-.408-.408H3.358a.409.409 0 00-.408.408v1.482a.234.234 0 10.469 0V.477h1.423v.963c0 .207.168.375.375.375h.588a.375.375 0 00.374-.375V.476h1.423v3.251H6.05a.234.234 0 00-.235.235v1.953H3.42v-3.08a.234.234 0 10-.469 0v3.08H1.57a.409.409 0 00-.408.408v3.46H.408a.409.409 0 00-.408.408v5.57c0 .13.105.234.234.234h2.482a.234.234 0 100-.468H.47v-5.275h3.298v.964c0 .206.168.374.374.374h.589a.375.375 0 00.374-.374v-.964h3.298v5.274H3.653a.234.234 0 100 .47h12.113c.13 0 .234-.106.234-.235v-4.32a.409.409 0 00-.408-.408zM5.71 1.346h-.399v-.87h.4v.87zm4.103 2.85v.87h-.4v-.87h.4zm-6.29 2.188h.4v.87h-.4v-.87zm-1.892 0h1.423v.964c0 .206.168.374.374.374h.589a.375.375 0 00.374-.374v-.964h1.423v3.4H1.631v-3.4zm3.004 4.737h-.4v-.87h.4v.87zm7.766.38v.87H12v-.87h.4zm3.13 4.026h-6.66v-4.025h2.662v.964c0 .206.168.374.374.374h.588a.375.375 0 00.375-.374v-.964h2.661v4.024z","fill":"#6C6C6C"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    